import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import AuthCallback from './components/AuthCallback';
import UserProfile from './components/UserProfile';
import ProtectedRoute from './components/ProtectedRoute';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './config/amplifyConfig';

Amplify.configure(amplifyConfig);

function App() {
  console.log('App component rendering');
  return (
    <Router>
      <AuthProvider>
        <Routes>
  <Route path="/callback" element={<AuthCallback />} />
  <Route path="/login" element={<Login />} />
  <Route 
    path="/dashboard" 
    element={
      <ProtectedRoute>
        <UserProfile />
      </ProtectedRoute>
    } 
  />
  <Route path="/" element={<AuthCallback />} /> {/* Handle root callback */}
</Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;